import type { FilterJourneyIndex } from '@/src/types/srpJourneyIndex'
import useSearchResults from '../useSearchResults'

/**
 * Resolves which slot in filterData.*[] to read/write.
 * - OW/RT: follows activeRtLeg (Redux / solution-flow selected leg)
 * - Multicity: uses explicit filterJourneyIndex; activeRtLeg stays 0 for card list & sort
 */
const useActiveFilterDataIndex = (filterJourneyIndex: FilterJourneyIndex = 0) => {
    const { isMulticity, activeRtLeg } = useSearchResults()
    const filterDataIndex = isMulticity ? filterJourneyIndex : activeRtLeg

    return { filterDataIndex, activeRtLeg, isMulticity }
}

export default useActiveFilterDataIndex
